import { t } from "i18next";
import { atom } from "jotai";
import { Invitation } from "shared/models";
import {
  revokeInvitation,
  getAllInvitations,
  sendInvite,
  resendInvitation,
} from "shared/requests";
import { authTokenAtom } from "./auth";
import { failedNotificationTypeAtom } from "./dashboard";
import { notificationAtom } from "./notification";

export const invitationsAtom = atom<Invitation[]>([]);

// Function to fetch all invitations
export const fetchAllInvitationsAtom = atom(
  (get) => get(invitationsAtom),
  async (get, set) => {
    // Get the token from the auth token atom
    const token = get(authTokenAtom);
    try {
      const invitations = await getAllInvitations(token);
      set(invitationsAtom, invitations);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  }
);

// Function to send post request to add invitation
export const inviteUserAtom = atom(
  null,
  async (get, set, invitedUser: Invitation) => {
    const token = get(authTokenAtom);
    try {
      const invitation = await sendInvite(invitedUser, token);
      set(invitationsAtom, (invitations) => [...invitations, invitation]);
      return invitation;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      set(notificationAtom, {
        isOpen: false,
        inProgress: false,
        message: "",
        severity: "none",
      });
      set(failedNotificationTypeAtom, "inviteUser");
    }
    return null; // Add a return statement here
  }
);

// Function to revoke an invitation
export const revokeInvitationAtom = atom(
  null,
  async (get, set, invitationId: string) => {
    const token = get(authTokenAtom);
    try {
      await revokeInvitation(invitationId, token);
      set(fetchAllInvitationsAtom);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      set(failedNotificationTypeAtom, "deleteInvite");
    }
  }
);

// Function to resend an invitation
export const resendInvitationAtom = atom(
  null,
  async (get, set, invitationId: string) => {
    const token = get(authTokenAtom);
    const invitations = get(invitationsAtom);
    const invitation = invitations.find((inv) => inv._id === invitationId);
    if (!invitation) {
      return;
    }
    try {
      await resendInvitation(invitationId, token);
      set(fetchAllInvitationsAtom);
      set(notificationAtom, {
        isOpen: true,
        message: t("notifications.invitationSent", {
          what: invitation.inviteeEmail,
        }),
        severity: "success",
        inProgress: false,
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      set(notificationAtom, {
        isOpen: false,
        inProgress: false,
        message: "",
        severity: "none",
      });
      set(failedNotificationTypeAtom, "resendInvite");
    }
  }
);
